var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7144 5.80737H4.28527C3.57517 5.80737 2.99951 6.3715 2.99951 7.06738V17.1474C2.99951 17.8433 3.57517 18.4074 4.28527 18.4074H19.7144C20.4245 18.4074 21.0001 17.8433 21.0001 17.1474V7.06738C21.0001 6.3715 20.4245 5.80737 19.7144 5.80737Z",
    stroke: "#257FFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7115 6.26904L13.7306 11.5308C13.235 11.9045 12.6271 12.1071 12.0017 12.1071C11.3763 12.1071 10.7685 11.9045 10.2728 11.5308L3.29199 6.26904",
    stroke: "#257FFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.99dd65de.svg";
export { ForwardRef as ReactComponent };